import ProjectSelector from './ProjectSelector'
import TransferToProjectDialog from './TransferToProjectDialog'

module.exports = {
  ProjectSelector,
  TransferToProjectDialog
}
